import React, { useEffect, useState } from 'react';
import authService from '../../services/auth.service';
import './PageLoader.scss';

const PageLoader: React.FC = () => {
  const [stuck, setStuck] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => setStuck(true), 8000);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <div className="page-loader">
      <div className="page-loader__spinner" />
      <p className="page-loader__text">Chargement...</p>
      {stuck ? (
        <div className="page-loader__recover">
          <p>Toujours bloqué ?</p>
          <button type="button" onClick={() => window.location.replace('/stores')}>
            Stores
          </button>
          <button type="button" onClick={() => window.location.reload()}>
            Recharger
          </button>
          <button
            type="button"
            onClick={() => {
              authService.clearAuthData();
              localStorage.removeItem('lastVisitedPage');
              window.location.replace('/login');
            }}
          >
            Déconnexion
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default PageLoader;
